import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "9ec678c7-75b8-403c-8f04-751df281500e",
    content: "The radial velocity is null",
    options: {},
  },
  {
    id: "29d0dba5-e7bc-4a9d-b358-1fffbb74a163",
    content: "The pressure is constant on the cross section",
    options: {},
  },
  {
    id: "e7101f93-59cc-4dee-8587-d0e5080cc541",
    content: "The normal velocity is constant on the cross section",
    options: {},
  },
  {
    id: "68def11b-e6a7-4092-b415-c28c607c7447",
    content: "The radial velocity is non-null",
    options: {},
  },
  {
    id: "c69766e8-0e1d-4fef-8b8a-13d7727b0c42",
    content: "The pressure is not constant on the cross section",
    options: {},
  },
  {
    id: "2541134d-aaa4-4308-abf3-7c25c02f1553",
    content: "The normal velocity is not constant on the cross section",
    options: {},
  },
];

export const task: Task = {
  id: "087da4bb-d866-4df9-9754-ef4b85c24ef5",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "e7101f93-59cc-4dee-8587-d0e5080cc541",
    "68def11b-e6a7-4092-b415-c28c607c7447",
    "c69766e8-0e1d-4fef-8b8a-13d7727b0c42",
    "2541134d-aaa4-4308-abf3-7c25c02f1553",
  ],
};
